import * as Yup from 'yup';

/**
 * Form configuration for archive requisition confirmation modal
 * Requires user to type "ARCHIVE" to confirm the action
 */
export const getArchiveRequisitionFormConfig = () => [
  {
    name: 'archiveInput',
    type: 'input',
    isRequired: true,
    placeholder: 'Type "ARCHIVE"',
    errorMessage: 'Confirmation message is required',
    validation: Yup.string()
      .oneOf(['ARCHIVE'], `Confirmation message doesn't match`)
      .required('Confirmation message is required'),
  },
];
